require('./addBankView.scss');
const {
  AGGREGATOR_NEW_FEATURES,
  AGGREGATOR_CONSENTS,
  AGGREGATOR_PSD2,
} = require('constants/flagBasedFeatures');

// @vendors
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
const { formatText } = require('core/i18n').i18n;
const { toFirstUppercase } = require('utilities/stringHelper');
import { withRouter } from 'react-router-dom';

// components
import AggregatorAddEntityModal from 'components/aggregator/aggregatorAddEntity/aggregatorAddEntityModal/aggregatorAddEntityModal';
import { OKCover } from 'commonsComponents/OKCover';
import { OKHeaderSubPage } from 'commonsComponents/OKHeaderSubPage';
import AggregatorTinkInfoAddBank from '../aggregatorTinkInfoAddBank/aggregatorTinkInfoAddBank';
import { OKButton } from 'components/commons/OKButton/OKButton';
import OKSelect from 'components/commons/OKSelect/OKSelect';
import { LoadingSection } from 'commonsComponents/loadingSection';
import { OKLink } from 'commonsComponents/OKLink';
import AggregatorAddEntityStepPSD2 from 'components/aggregator/aggregatorAddEntity/aggregatorAddEntityStepPSD2/aggregatorAddEntityStepPSD2';
import { AggregatorAddEntityStepLogin } from 'components/aggregator/aggregatorAddEntity/aggregatorAddEntityStepLogin/aggregatorAddEntityStepLogin';
import OKModal from 'commonsComponents/OKModal';

// constants
import {
  ERROR,
  CREDENTIALS_ID_TINK_LINK,
  STATE_TINK_LINK,
} from '../constants/keysCallBack/keysCallBack.contants';
import { SELECTED_BANK, PSD2_FLOW_TYPE } from 'constants/aggregator/localStorageKeys';
import { CREATE_CONSENT } from 'constants/aggregator/psd2DecoupledFlowType';
const isSecondTinkSucceded = 'isSecondTinkSucceded';
const selectorPageUrl = '/myprofile/global/entities/add';
const TRANSLATION_KEY_PREFIX = 'aggregatorAddEntity';

// assets
import iconTick from '../assets/tick.svg';
import iconError from '../assets/error.svg';
import success from '../assets/success.svg';

// @actions
import {
  getBanksTink,
  getTinkUrl,
  getCreateUserBanksTink,
  refreshAggregationTink,
  handleTermsAndConditionsTink,
  getDataBank,
  setFormValue,
  sendFormInfo,
  clearFormValues,
  clearAddEntity,
} from 'actions/aggregator/aggregatorAddEntity';
import { getGlobalPositionTink } from 'actions/aggregator/aggregatorData';
import { requestUrl, initStorePSD2 } from 'actions/aggregator/aggregatorAddEntityPSD2';

// @utilities
const {
  recordPage,
  recordLink,
  TINK_ADD_BANK_PAGE_NAME,
  TINK_ADD_BANK_PROCESS_TYPE,
  TINK_PROCESS_STEP_INITIAL,
  TINK_PROCESS_STEP_SUCCESS,
  TINK_PROCESS_STEP_ERROR,
  TINK_ADD_BANK_SELECT_BANK_IMG,
  TINK_ADD_BANK_ADD_CREDENTIALS_BUTTON,
  TINK_ADD_BANK_ADD_BANK_BUTTON,
  TINK_ADD_BANK_SEARCHER_DROPDOWN,
  TINK_ADD_BANK_SEARCHER_DROPDOWN_TAG,
  TINK_ADD_BANK_CANCEL_LINK,
  TINK_ADD_BANK_NEXT_BUTTON,
  TINK_ADD_BANK_RETRY_BUTTON,
  TINK_ADD_BANK_GO_BACK_GP_LINK,
  PROC_ADD_ENTITY_ERROR,
  PROC_RESTART,
} = require('utilities/tagging');
import Storage from 'utilities/storage';
import UrlHelper from 'utilities/urlHelper';
import { isFormFilled } from 'utilities/aggregator/aggregatorFormHelper';
const { scrollToTop } = require('commonsUtilities/scrollUtils');

class AddBankViewClass extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      bankSelected: null,
      eurobitsSecondStep: false,
      eurobitsNoPSD2LastStep: false,
      eurobitsNoPDS2SubmmitDone: false,
      hasEurobitsNoPDS2SubmmitError: false,
      reStartAggEurobits: false,
    };
  }

  componentDidMount() {
    // For Tink
    const { getBanksTink, getCreateUserBanksTink, getGlobalPositionTink, refreshAggregationTink } =
      this.props;

    const queryString = window.location.search;
    const isMainUrlPage =
      !queryString ||
      (queryString && !queryString.includes(CREDENTIALS_ID_TINK_LINK));

    const urlParams = new URLSearchParams(queryString);
    const error = urlParams.get(ERROR);
    const isTinkSuccessView = !isMainUrlPage && !error;

    getBanksTink();
    getGlobalPositionTink();

    if (isTinkSuccessView) {
      const credentialIdTinkLink = urlParams.get(CREDENTIALS_ID_TINK_LINK);
      const stateTinkLink = urlParams.get(STATE_TINK_LINK);

      const userBankId = JSON.parse(sessionStorage.getItem('userBankId'));

      stateTinkLink
        ? getCreateUserBanksTink(credentialIdTinkLink, stateTinkLink)
        : refreshAggregationTink(userBankId);
    }

    recordPage({
      nombrePagina: TINK_ADD_BANK_PAGE_NAME,
      tipoProceso: TINK_ADD_BANK_PROCESS_TYPE,
      pasoProceso: this.getLabelByStatus(),
    });

    if (localStorage.getItem(isSecondTinkSucceded && isMainUrlPage)) {
      localStorage.removeItem(isSecondTinkSucceded);
    }
  }

  componentDidUpdate() {
    // For Eurobits
    const { getBanksTink, getGlobalPositionTink, immAggregatorAddEntity } = this.props;
    const { reStartAggEurobits } = this.state;

    scrollToTop();

    const eurobitsError =
      immAggregatorAddEntity.get('error') || immAggregatorAddEntity.getIn(['steps', 1, 'error']);

    if (eurobitsError) {
      this.setState({
        hasEurobitsNoPDS2SubmmitError: true,
      });
    }
    if (reStartAggEurobits) {
      getBanksTink();
      getGlobalPositionTink();
      this.setState({
        reStartAggEurobits: false,
      });
    }
  }

  componentWillUnmount() {
    // For Eurobits
    const { clearFormValues, clearAddEntity } = this.props;

    clearFormValues();
    clearAddEntity();

    // For Tink
    if (sessionStorage.getItem('userBankId')) {
      sessionStorage.removeItem('userBankId');
    }
  }

  getLabelByStatus = () => {
    const { immAggregatorAddEntity } = this.props;
    const queryString = window.location.search;
    const isMainUrlPage =
      !queryString ||
      (queryString && !queryString.includes(CREDENTIALS_ID_TINK_LINK));
    const urlParams = new URLSearchParams(queryString);
    const eurobitsError =
      immAggregatorAddEntity.get('error') || immAggregatorAddEntity.getIn(['steps', 1, 'error']);
    const error = urlParams.get(ERROR) || eurobitsError;

    if (isMainUrlPage) {
      return TINK_PROCESS_STEP_INITIAL;
    } else {
      return error ? TINK_PROCESS_STEP_ERROR : TINK_PROCESS_STEP_SUCCESS;
    }
  };

  getSelectOptions = () => {
    const { immAggregatorAddEntity } = this.props;

    const banks = immAggregatorAddEntity.getIn(['steps', 0, 'banks'], {});

    // bankList from v4/banks
    const mappedBanks = banks.toJS().bankList.map(bank => {
      const { tinkPsd2Enabled, tinkScrappingEnabled, tinkPsd2BankCode, tinkBankCode, robotCode } =
        bank;
      const doTinkAggregation = tinkPsd2Enabled || tinkScrappingEnabled;
      const bankCodeForTinkAgg = tinkPsd2Enabled ? tinkPsd2BankCode : tinkBankCode;
      const bankCode = doTinkAggregation ? bankCodeForTinkAgg : robotCode;

      return {
        value: bankCode,
        label: bank.frontName,
        bankSelected: bank,
      };
    });

    return !banks ? [] : mappedBanks;
  };

  handleBankImgSelector = bank => {
    const { getDataBank } = this.props;

    const { tinkPsd2Enabled, tinkScrappingEnabled, tinkPsd2BankCode, tinkBankCode, robotCode } =
      bank;
    const bankCode = tinkPsd2Enabled ? tinkPsd2BankCode : tinkBankCode;
    const doTinkAggregation = tinkPsd2Enabled || tinkScrappingEnabled;

    this.setState({
      bankSelected: bankCode,
    });

    sessionStorage.setItem('bankSelected', JSON.stringify(bank));
    sessionStorage.setItem('doTinkAggregation', JSON.stringify(doTinkAggregation));

    if (!doTinkAggregation) {
      getDataBank(robotCode);
      this.setState({ eurobitsSecondStep: true });
    }

    recordLink(TINK_ADD_BANK_PAGE_NAME, TINK_ADD_BANK_SELECT_BANK_IMG, this.state.bankSelected);
  };

  handleOnChangeDropDown = selectedOption => {
    const { label, value, bankSelected } = selectedOption;
    const { getDataBank } = this.props;

    const { tinkPsd2Enabled, tinkScrappingEnabled, robotCode } = bankSelected;
    const doTinkAggregation = tinkPsd2Enabled || tinkScrappingEnabled;
    const selectedBankName = label;

    this.setState({ bankSelected: value });

    sessionStorage.setItem('bankSelected', JSON.stringify(selectedOption));
    sessionStorage.setItem('doTinkAggregation', JSON.stringify(doTinkAggregation));

    if (!doTinkAggregation) {
      getDataBank(robotCode);
    }

    recordLink(TINK_ADD_BANK_PAGE_NAME, TINK_ADD_BANK_SEARCHER_DROPDOWN, selectedBankName);
  };

  handleOnFocusDropDown = () =>
    recordLink(
      TINK_ADD_BANK_PAGE_NAME,
      TINK_ADD_BANK_SEARCHER_DROPDOWN,
      TINK_ADD_BANK_SEARCHER_DROPDOWN_TAG
    );

  renderNoPSD2EurobitsSecondStep = () => {
    const { immAggregatorAddEntity, getDataBank, setFormValue, clearFormValues } = this.props;

    const bank = JSON.parse(sessionStorage.getItem('bankSelected'));

    const immLoginStep = immAggregatorAddEntity.getIn(['steps', 1]);

    const name = bank && bank.frontName;
    const bankId = bank && bank.robotCode;
    const imgUrl = bank && bank.imageUrl;

    return (
      <AggregatorAddEntityStepLogin
        getDataBank={getDataBank}
        form={immLoginStep.get('form')}
        beta={immLoginStep.get('beta')}
        setFormValue={setFormValue}
        clearFormValues={clearFormValues}
        bankId={bankId}
        bankUniqueId={bankId}
        isFetching={immLoginStep.get('isFetching')}
        name={name}
        url={imgUrl}
        values={immAggregatorAddEntity.get('values')}
        submitFetching={immLoginStep.get('fetchingform')}
      />
    );
  };

  renderPSD2EurobitsSecondStep = () => {
    const { requestUrl, initStorePSD2 } = this.props;

    const bank = JSON.parse(sessionStorage.getItem('bankSelected'));

    const name = bank && bank.frontName;
    const bankId = bank && bank.robotCode;
    const imgUrl = bank && bank.imageUrl;

    return (
      <AggregatorAddEntityStepPSD2
        bankUniqueId={bankId}
        name={name}
        url={imgUrl}
        requestUrl={requestUrl}
        initStorePSD2={initStorePSD2}
      />
    );
  };

  getIsEurobitsPSD2Flow = () => {
    const { immAggregatorAddEntity, immFlagBasedFeatures } = this.props;

    const immLoginStep = immAggregatorAddEntity.getIn(['steps', 1]);

    const isPsd2Eurobits = immLoginStep.get('psd2Supported');
    const isAggPsd2Eurobits = immFlagBasedFeatures.get(AGGREGATOR_PSD2);

    return isPsd2Eurobits && isAggPsd2Eurobits ? true : false;
  };

  handleEurobitsPSD2NextButton = (immBankData, redirectionUrl = '') => {
    const { aggregatorData } = this.props;
    const { eurobitsSecondStep } = this.state;
    const { name, logo, code, psd2Info } = immBankData ? immBankData.toJS() : {};
    const scrapingCredentials =
      aggregatorData.getIn(['banks', code, 'scrapingCredentials']) || false;

    Storage.localStorage.set(SELECTED_BANK, {
      bankName: name,
      bankLogo: logo,
      bankCode: code,
      bankManagement: psd2Info.consentManagementMode,
      scrapingCredentials,
    });
    Storage.localStorage.set(PSD2_FLOW_TYPE, CREATE_CONSENT);

    UrlHelper.redirectToExternalURL(redirectionUrl);

    !eurobitsSecondStep && this.setState({ eurobitsSecondStep: true });
  };

  handleEurobitsNoPSD2NextButton = () => {
    this.setState({ eurobitsSecondStep: true, eurobitsNoPSD2LastStep: true });
  };

  handleNextButton = () => {
    const { getTinkUrl, immAggregatorAddEntity, redirectionUrl } = this.props;
    const { bankSelected } = this.state;
    const immLoginStep = immAggregatorAddEntity.getIn(['steps', 1]);

    const doTinkAggregation = JSON.parse(sessionStorage.getItem('doTinkAggregation'));

    if (doTinkAggregation) {
      getTinkUrl(bankSelected);
    } else {
      this.getIsEurobitsPSD2Flow()
        ? this.handleEurobitsPSD2NextButton(immLoginStep, redirectionUrl)
        : this.handleEurobitsNoPSD2NextButton();
    }

    recordLink(TINK_ADD_BANK_PAGE_NAME, TINK_ADD_BANK_NEXT_BUTTON, TINK_ADD_BANK_NEXT_BUTTON);
  };

  handleAddNoPSD2BankEurobits = () => {
    const { sendFormInfo, immAggregatorAddEntity } = this.props;
    const immLoginStep = immAggregatorAddEntity.getIn(['steps', 1]);

    sendFormInfo(
      immLoginStep.get('publicKey'),
      immLoginStep.get('code'),
      immAggregatorAddEntity.get('values')
    );

    this.setState({
      eurobitsSecondStep: false,
      eurobitsNoPSD2LastStep: false,
      bankSelected: null,
      eurobitsNoPDS2SubmmitDone: true,
    });
  };

  getIsGoToBankButtonDisabled = () => {
    const { immAggregatorAddEntity } = this.props;
    const immLoginStep = immAggregatorAddEntity.getIn(['steps', 1]);

    return !isFormFilled(immLoginStep.get('form'), immAggregatorAddEntity.get('values'));
  };

  handleAddCredentialsButton = (code, userBankId) => {
    const { getTinkUrl, sendFormInfo, immAggregatorAddEntity } = this.props;
    const immLoginStep = immAggregatorAddEntity.getIn(['steps', 1]);

    const doTinkAggregation = JSON.parse(sessionStorage.getItem('doTinkAggregation'));

    if (doTinkAggregation) {
      getTinkUrl(code, userBankId);
    } else {
      sendFormInfo(
        immLoginStep.get('publicKey'),
        immLoginStep.get('code'),
        immAggregatorAddEntity.get('values'),
        userBankId
      );
      this.setState({ eurobitsNoPDS2SubmmitDone: false });
    }

    if (doTinkAggregation && !localStorage.getItem(isSecondTinkSucceded)) {
      localStorage.setItem(isSecondTinkSucceded, true);
    }

    recordLink(
      `${TINK_ADD_BANK_PAGE_NAME}/${TINK_PROCESS_STEP_SUCCESS}`,
      TINK_ADD_BANK_ADD_CREDENTIALS_BUTTON,
      TINK_ADD_BANK_ADD_CREDENTIALS_BUTTON
    );
  };

  handleAddBankButton = () => {
    if (localStorage.getItem(isSecondTinkSucceded)) {
      localStorage.removeItem(isSecondTinkSucceded);
    }

    this.props.history.replace(selectorPageUrl);

    recordLink(
      `${TINK_ADD_BANK_PAGE_NAME}/${TINK_PROCESS_STEP_SUCCESS}`,
      TINK_ADD_BANK_ADD_BANK_BUTTON,
      TINK_ADD_BANK_ADD_BANK_BUTTON
    );
  };

  handleRetryButton = hasNotBanks => {
    hasNotBanks ? this.props.getBanksTink() : this.props.history.replace(selectorPageUrl);

    this.setState({
      eurobitsSecondStep: false,
      eurobitsNoPSD2LastStep: false,
      bankSelected: null,
      eurobitsNoPDS2SubmmitDone: false,
      hasEurobitsNoPDS2SubmmitError: false,
    });

    recordLink(
      `${TINK_ADD_BANK_PAGE_NAME}/${TINK_PROCESS_STEP_ERROR}`,
      TINK_ADD_BANK_RETRY_BUTTON,
      TINK_ADD_BANK_RETRY_BUTTON
    );
  };

  handleLinkTagging = (isMainUrlPage, isErrorStep) => {
    const linkCategory = isMainUrlPage
      ? TINK_ADD_BANK_PAGE_NAME
      : `${TINK_ADD_BANK_PAGE_NAME}/${
          isErrorStep ? TINK_PROCESS_STEP_ERROR : TINK_PROCESS_STEP_SUCCESS
        }`;
    const linkEvent = isMainUrlPage ? TINK_ADD_BANK_CANCEL_LINK : TINK_ADD_BANK_GO_BACK_GP_LINK;

    recordLink(linkCategory, linkEvent, linkEvent);
  };

  handleModalButtonClick = () => {
    this.props.clearAddEntity();

    this.setState({
      eurobitsSecondStep: false,
      eurobitsNoPSD2LastStep: false,
      bankSelected: null,
      eurobitsNoPDS2SubmmitDone: false,
      hasEurobitsNoPDS2SubmmitError: false,
      reStartAggEurobits: true,
    });
  };

  handleOnClickMainButton = () => {
    this.props.clearAddEntity();

    this.setState({
      eurobitsSecondStep: false,
      eurobitsNoPSD2LastStep: false,
      bankSelected: null,
      eurobitsNoPDS2SubmmitDone: false,
      hasEurobitsNoPDS2SubmmitError: false,
      reStartAggEurobits: true,
    });

    recordLink(PROC_ADD_ENTITY_ERROR, PROC_RESTART);
  };

  render() {
    const {
      immAggregatorAddEntity,
      immFlagBasedFeatures,
      handleTermsAndConditionsTink,
      hasAggregatedBanks,
      aggDataError,
      errorRedirectionUrl,
    } = this.props;
    const { eurobitsNoPDS2SubmmitDone, hasEurobitsNoPDS2SubmmitError } = this.state;

    const queryString = window.location.search;
    const isMainUrlPage =
      !queryString ||
      (queryString && !queryString.includes(CREDENTIALS_ID_TINK_LINK));
    const urlParams = new URLSearchParams(queryString);
    const eurobitsError =
      immAggregatorAddEntity.get('error') || immAggregatorAddEntity.getIn(['steps', 1, 'error']);
    const error = urlParams.get(ERROR) || eurobitsError;
    const showInfoColumn = true;
    const isLoadingSection = immAggregatorAddEntity.getIn(['steps', 0, 'isFetching'], {});
    const doTinkAggregation = JSON.parse(sessionStorage.getItem('doTinkAggregation'));
    const isTinkErrorView = !isMainUrlPage && error;
    const isTinkSuccessView = !isMainUrlPage && !error;

    const bootstrapGridClasses = classNames({
      'col-md-12': !isMainUrlPage,
      'col-xs-12 col-md-8': isMainUrlPage,
    });

    const renderSuccessView = (
      bankName,
      bankImage,
      showTextOnlyPSD2,
      showCredentialsBtn,
      credentialsCode,
      userBankId,
      isSecondTinkSucceded
    ) => {
      return (
        <div className="success-view">
          <div className="success-view__image">
            <img src={success} />
          </div>
          <div>
            <h2 className="success-view__title">
              {formatText('aggregatorAddEntitySuccess-title', [bankName || ''])}
            </h2>
            <div>
              <p className="success-view__paragraph">
                {formatText('aggregatorAddEntitySuccess-text')}
              </p>
              {showTextOnlyPSD2 && (
                <p className="success-view__paragraph">
                  {formatText('aggregatorPSD2-consentOkSecondaryText')}
                </p>
              )}
            </div>
            <div style={{ margin: '30px 0' }}>
              <img className="success-view__logo" src={bankImage} alt={bankName} title={bankName} />
            </div>
            <footer className="success-view__footer">
              {doTinkAggregation && showCredentialsBtn && !isSecondTinkSucceded && (
                <OKButton
                  loading={immAggregatorAddEntity.toJS().getTinkUrlFetching}
                  modifier="secondary"
                  onClick={() => this.handleAddCredentialsButton(credentialsCode, userBankId)}
                >
                  {formatText('aggregatorPSD2-consentOkCredentialsButton')}
                </OKButton>
              )}
              {doTinkAggregation ? (
                (!showCredentialsBtn || isSecondTinkSucceded) && (
                  <OKButton modifier="secondary" onClick={() => this.handleAddBankButton()}>
                    {formatText('aggregatorAddEntitySuccess-button')}
                  </OKButton>
                )
              ) : (
                <OKButton modifier="secondary" onClick={() => this.handleOnClickMainButton()}>
                  {formatText('aggregatorAddEntitySuccess-button')}
                </OKButton>
              )}
              <OKLink
                modifier="complementary"
                to="/myprofile/global"
                onClick={() => this.handleLinkTagging(false, false)}
              >
                {formatText('aggregatorAddEntitySuccess-secondaryButton')}
              </OKLink>
            </footer>
          </div>
        </div>
      );
    };

    const renderErrorView = (hasNotBanks, bankName) => {
      const title = formatText(
        !hasNotBanks ? 'aggregatorPSD2-credentialsKoTitle' : 'aggregatorAddEntity-errorTitle',
        [bankName || '']
      );
      const paragraph = formatText(
        !hasNotBanks
          ? 'aggregatorPSD2-credentialsKoInformation'
          : 'aggregatorAddEntity-errorBanksMessage'
      );
      const buttonTag = formatText(
        !hasNotBanks ? 'aggregatorPSD2-credentialsKoRetryButton' : 'aggregatorAddEntity-retryButton'
      );
      const linkTag = formatText(
        !hasNotBanks
          ? 'aggregatorPSD2-credentialsKoBackGlobalPositionButton'
          : 'aggregatorAddEntity-backToGlobalPosition'
      );

      return (
        <div className="error-view">
          <div className="error-view__image">
            <img src={iconError} />
          </div>
          <div style={{ width: '100%' }}>
            <h2 className="error-view__title">{title}</h2>
            <p className="error-view__paragraph">{paragraph}</p>
            <footer className="error-view__footer">
              <OKButton modifier="ghost" onClick={() => this.handleRetryButton(hasNotBanks)}>
                {buttonTag}
              </OKButton>
              <OKLink
                modifier="complementary"
                to="/myprofile/global"
                onClick={() => this.handleLinkTagging(false, true)}
              >
                {linkTag}
              </OKLink>
            </footer>
          </div>
        </div>
      );
    };

    let banks;
    let contentPage;

    if (isMainUrlPage) {
      const { immAggregatorAddEntity, aggDataError } = this.props;
      const { reStartAggEurobits } = this.state;

      banks = immAggregatorAddEntity.getIn(['steps', 0, 'banks'], {});

      const bankList = banks && banks.toJS().bankList;
      const hasNotBanks = (bankList && bankList.length === 0) || bankList === null;

      contentPage =
        ((!eurobitsNoPDS2SubmmitDone && !reStartAggEurobits && hasNotBanks && !isLoadingSection) ||
          (hasEurobitsNoPDS2SubmmitError && !reStartAggEurobits)) &&
        renderErrorView(hasNotBanks);

      const bankSelected = JSON.parse(sessionStorage.getItem('bankSelected'));

      const bankName = bankSelected && bankSelected.frontName;
      const bankImage = bankSelected && bankSelected.imageUrl;
      const eurobitsBankCode = bankSelected && bankSelected.robotCode;

      const userBank = immAggregatorAddEntity.toJS().userBank;
      const userBankId = userBank && userBank.userBankId;

      if (aggDataError) {
        contentPage = !isLoadingSection && renderErrorView(true);
      } else if (banks) {
        const { isFetchingUrl } = this.props;
        const { bankSelected, eurobitsSecondStep, eurobitsNoPSD2LastStep } = this.state;

        const nextArrowIcon = 'icon-siguiente';

        const contentPageSelector = banks.toJS().bankList.map((bank, index) => {
          const bankCode = bank.tinkPsd2BankCode || bank.tinkBankCode;

          return (
            bank.showOnGrid && (
              <div
                className={`add-bank-view-bank-data ${
                  bankSelected === bankCode ? '-selected' : ''
                }`}
                onClick={() => this.handleBankImgSelector(bank)}
                key={index}
              >
                {bankSelected === bankCode && <img className="icon-selected" src={iconTick} />}
                <img
                  className="bank-image"
                  alt={bank.frontName}
                  title={bank.frontName}
                  src={bank.imageUrl}
                />
              </div>
            )
          );
        });

        const contentPageEurobitsBankSelected = this.getIsEurobitsPSD2Flow()
          ? this.renderPSD2EurobitsSecondStep()
          : this.renderNoPSD2EurobitsSecondStep();

        const finalButtonText = TRANSLATION_KEY_PREFIX + '-finalButton';

        const renderSelectorView = () => {
          return (
            <React.Fragment>
              {eurobitsSecondStep ? (
                <div className="add-bank-view">{contentPageEurobitsBankSelected}</div>
              ) : (
                <Fragment>
                  <h2 className="title-selector">
                    {formatText('aggregatorAddEntity-selectEntityToAdd')}
                  </h2>
                  <div className="add-bank-view">{contentPageSelector}</div>
                  <div className="add-bank-view__search aggregator-add-entity__wizard__wizard-step-select-bank__content__search">
                    <OKSelect
                      label="aggregatorAddEntity-selectBankSelectorLabel"
                      value={bankSelected}
                      onChange={selectedOption => this.handleOnChangeDropDown(selectedOption)}
                      onFocus={this.handleOnFocusDropDown}
                      options={this.getSelectOptions()}
                    />
                  </div>
                </Fragment>
              )}
              <div className="content-footer">
                {eurobitsSecondStep ? (
                  <OKButton
                    modifier="ghost"
                    onClick={() => {
                      this.setState({
                        eurobitsSecondStep: false,
                        eurobitsNoPSD2LastStep: false,
                        bankSelected: null,
                      });
                    }}
                  >
                    {formatText('aggregatorPSD2-consentStepCancelButton')}
                  </OKButton>
                ) : (
                  <OKLink
                    modifier="dark"
                    extraClass="cancel-link"
                    isOKLinkOld={true}
                    to={'/myprofile/global'}
                    onClick={() => this.handleLinkTagging(true)}
                  >
                    {formatText('aggregatorPSD2-consentStepCancelButton')}
                  </OKLink>
                )}
                {eurobitsNoPSD2LastStep ? (
                  <OKButton
                    onClick={this.handleAddNoPSD2BankEurobits}
                    disabled={this.getIsGoToBankButtonDisabled()}
                  >
                    {formatText(finalButtonText)}
                  </OKButton>
                ) : (
                  <OKButton
                    loading={
                      doTinkAggregation
                        ? immAggregatorAddEntity.toJS().getTinkUrlFetching
                        : isFetchingUrl
                    }
                    onClick={this.handleNextButton}
                    disabled={!bankSelected}
                    rightIcon={nextArrowIcon}
                  >
                    {toFirstUppercase(formatText('buttonsActions-next'))}
                  </OKButton>
                )}
              </div>
            </React.Fragment>
          );
        };

        contentPage = isLoadingSection && (
          <div className="loading-section">
            <LoadingSection />
          </div>
        );

        const renderEurobitsNoPSD2OutcomeView = () => {
          recordPage({
            nombrePagina: TINK_ADD_BANK_PAGE_NAME,
            tipoProceso: TINK_ADD_BANK_PROCESS_TYPE,
            pasoProceso: this.getLabelByStatus(),
          });

          return !hasEurobitsNoPDS2SubmmitError
            ? // EUROBITS NoPSD2 - SUCCESS VIEW
              renderSuccessView(bankName, bankImage, null, null, eurobitsBankCode, userBankId)
            : // EUROBITS NoPSD2 - ERROR VIEW
              renderErrorView(hasNotBanks, bankName);
        };

        contentPage =
          !isLoadingSection &&
          (!eurobitsNoPDS2SubmmitDone
            ? // SELECTOR VIEW
              renderSelectorView()
            : // EUROBITS NoPSD2 - SUCCESS OR ERROR VIEW
              renderEurobitsNoPSD2OutcomeView());
      }
    }
    // TINK - ERROR VIEW
    else if (isTinkErrorView) {
      const bankSelected = JSON.parse(sessionStorage.getItem('bankSelected'));
      const bankName = bankSelected.frontName;
      const bankList = banks && banks.toJS().bankList;
      const hasNotBanks = (bankList && bankList.length === 0) || bankList === null;

      contentPage = renderErrorView(hasNotBanks, bankName);
    }
    // TINK - SUCCESS VIEW
    else if (isTinkSuccessView || localStorage.getItem(isSecondTinkSucceded)) {
      const { aggBanksTink } = this.props;

      const bankSelected = JSON.parse(sessionStorage.getItem('bankSelected'));
      const {
        frontName,
        imageUrl,
        tinkPsd2Enabled,
        tinkScrappingEnabled,
        tinkBankCode,
        tinkPsd2CredentialsId,
        tinkCredentialId,
      } = bankSelected;

      const userBank = immAggregatorAddEntity.toJS().userBank;
      const userBankId = userBank && userBank.userBankId;

      const showCredentialsBtn = tinkPsd2CredentialsId && !tinkCredentialId && tinkScrappingEnabled;
      const showTextOnlyPSD2 = tinkPsd2Enabled && !tinkScrappingEnabled;

      const userBankIdAfterBankRefreshed = JSON.parse(sessionStorage.getItem('userBankId'));
      const refreshedCredentialsBank = aggBanksTink.find(
        bank => bank.userBankId === userBankIdAfterBankRefreshed
      );
      const refreshedBankName = refreshedCredentialsBank && refreshedCredentialsBank.name;
      const refreshedBankImg = refreshedCredentialsBank && refreshedCredentialsBank.imageUrl;

      const bankName = frontName || refreshedBankName;
      const bankImage = imageUrl || refreshedBankImg;

      contentPage = renderSuccessView(
        bankName,
        bankImage,
        showCredentialsBtn,
        showTextOnlyPSD2,
        tinkBankCode,
        userBankId,
        !!localStorage.getItem(isSecondTinkSucceded)
      );
    }

    return (
      <Fragment>
        {!hasAggregatedBanks && !aggDataError && !isLoadingSection && (
          <AggregatorAddEntityModal
            showModal={!hasAggregatedBanks}
            immAggregatorAddEntity={immAggregatorAddEntity}
            handleTermsAndConditions={handleTermsAndConditionsTink}
            newCategorized={immFlagBasedFeatures.get(AGGREGATOR_NEW_FEATURES)}
            newConsents={immFlagBasedFeatures.get(AGGREGATOR_CONSENTS)}
          />
        )}

        <div className="aggregator-add-entity-view">
          <div className="container-fluid">
            <div className="row">
              <OKCover size="medium" section="accounts" customClass="col-xs-12">
                <OKHeaderSubPage
                  breadcrumbConfig={[
                    {
                      text: formatText('breadcrumb-global'),
                      url: '/myprofile/global',
                    },
                    {
                      text: formatText('breadcrumb-aggregatorAddEntity'),
                      url: '',
                    },
                  ]}
                  finalTitle={formatText('aggregatorAddEntity-headerTitle')}
                ></OKHeaderSubPage>
              </OKCover>
            </div>
          </div>
          <div className="grid-view__body">
            <div className="container-fluid">
              <div className="row grid-view--content-position-negative">
                <div className={bootstrapGridClasses}>
                  <div
                    className={`add-bank-content ${
                      !isMainUrlPage ? 'col-xs-offset-1 col-xs-10' : ''
                    }`}
                  >
                    {contentPage}
                  </div>
                </div>
                {showInfoColumn && isMainUrlPage && <AggregatorTinkInfoAddBank />}
              </div>
            </div>
          </div>
        </div>
        {!doTinkAggregation && (
          <OKModal
            isOpen={errorRedirectionUrl}
            title={formatText('aggregatorPSD2-redirectionUrlErrorTitle')}
            content={formatText('aggregatorPSD2-redirectionUrlErrorMessage')}
            footerType="action"
            primaryButtonText={formatText('aggregatorPSD2-redirectionUrlErrorButton')}
            onPrimaryButtonClick={this.handleModalButtonClick}
            customCloseButton={<div />}
          />
        )}
      </Fragment>
    );
  }
}

AddBankViewClass.propTypes = {
  aggregatorData: PropTypes.object,
  getBanksTink: PropTypes.function,
  history: PropTypes.object.isRequired,
  immAggregatorAddEntity: PropTypes.object,
  immFlagBasedFeatures: PropTypes.object,
  handleTermsAndConditionsTink: PropTypes.function,
  getTinkUrl: PropTypes.function,
  getCreateUserBanksTink: PropTypes.function,
  refreshAggregationTink: PropTypes.function,
  getGlobalPositionTink: PropTypes.function,
  hasAggregatedBanks: PropTypes.bool,
  aggDataError: PropTypes.bool,
  sendFormInfo: PropTypes.function,
  getDataBank: PropTypes.function,
  requestUrl: PropTypes.func,
  initStorePSD2: PropTypes.func,
  redirectionUrl: PropTypes.string,
  isFetchingUrl: PropTypes.bool,
  setFormValue: PropTypes.func.isRequired,
  clearFormValues: PropTypes.func,
  form: PropTypes.object,
  values: PropTypes.object,
  clearAddEntity: PropTypes.func.isRequired,
  errorRedirectionUrl: PropTypes.object,
  bank: PropTypes.object,
  aggBanksTink: PropTypes.object,
};

const AddBankView = withRouter(
  connect(
    (state, ownProps) => {
      const aggDataTink = state.aggregatorData.toJS().data;
      const aggBanksTink = aggDataTink.banks && Object.values(aggDataTink.banks);
      const aggDataError = state.aggregatorData.toJS().error;

      return {
        aggregatorData: state.aggregatorData,
        immAggregatorAddEntity: state.aggregatorAddEntity,
        immFlagBasedFeatures: state.flagBasedFeatures,
        hasAggregatedBanks: aggBanksTink && aggBanksTink.length > 0,
        aggDataError,
        redirectionUrl: state.aggregatorAddEntityPSD2.get('redirectionUrl'),
        isFetchingUrl: state.aggregatorAddEntityPSD2.get('isFetchingUrl'),
        errorRedirectionUrl: state.aggregatorAddEntityPSD2.get('error'),
        bank: state.aggregatorData.getIn([
          'data',
          'banks',
          ownProps && ownProps.match && ownProps.match.params && ownProps.match.params.userBankId,
        ]),
        aggBanksTink,
      };
    },
    {
      getBanksTink,
      getTinkUrl,
      getCreateUserBanksTink,
      refreshAggregationTink,
      handleTermsAndConditionsTink,
      getGlobalPositionTink,
      sendFormInfo,
      getDataBank,
      requestUrl,
      initStorePSD2,
      setFormValue,
      clearFormValues,
      clearAddEntity,
    }
  )(AddBankViewClass)
);

export { AddBankView };
